import { cn } from '../../lib/cn';
import { Card } from '../ui';

type Metric = { label: string; status: string; detail: string };

type Props = {
  metrics: Metric[];
};

function statusColor(status: string): string {
  if (status === 'healthy') return 'bg-success-500';
  if (status === 'warning') return 'bg-warning-500';
  return 'bg-error-500';
}

export function WorkspaceHealthPanel({ metrics }: Props) {
  return (
    <Card padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Workspace Health</p>
      <ul className="mt-3 space-y-2">
        {metrics.map((m) => (
          <li key={m.label} className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <span className={cn('h-2 w-2 rounded-full', statusColor(m.status))} aria-hidden="true" />
              <span className="text-slate-700 dark:text-slate-300">{m.label}</span>
            </div>
            <span className="text-xs text-slate-500">{m.detail}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
